export const modalNovoCicloStyles = {}
